import React from 'react';
import './Styles.css';

const HashRouting = () => (
  <div className="content">
    <h1>Hash Routing</h1>
    <h2>What is Hash Routing?</h2>
    <p>
      Hash routing uses a hash symbol in the URL to track navigation state of the application. When a hash change occurs, the web browser does not send a request to the server. Instead, JavaScript can listen for hash changes and react accordingly.
    </p>
    <h2>Hash Routing vs. History Routing</h2>
    <p>
      Traditional web apps use history routing, where each unique URL corresponds to a different resource on the server. However, in a single page application (SPA) like this React app, all necessary code is loaded on the initial page load or dynamically loaded as the user navigates around the app.
    </p>
    <p>
      History routing in an SPA requires server-side configuration to direct all requests back to the single HTML file. However, hash routing doesn't need any server-side configuration as the server only sees the URL before the '#', and the JavaScript on the client side uses the part after the '#' to handle the page state.
    </p>
    <h2>Why Hash Routing for ArDrive?</h2>
    <p>
      When you deploy an app on ArDrive, the app is uploaded to the Arweave permaweb which is a set of decentralized servers. Since there's no central server where we can configure how requests are handled, history routing doesn't work properly. Hash routing is thus the perfect solution as it handles all routing on the client side.
    </p>
    <h2>Implementing Hash Routing in this App</h2>
    <p>
      This React app uses the `react-router-dom` library to implement hash routing. The `HashRouter` component is used in `App.js` to create hash-based URLs. Each `Route` defined within `HashRouter` corresponds to a different component that gets displayed when the URL's hash matches the `Route`'s path.
    </p>
    <p>
      This means that when you navigate around the app, the part of the URL after the '#' changes to match the path of the corresponding `Route`. The `HashRouter` listens for these changes and displays the correct component without any server request being made.
    </p>
    <p>
      In addition to this, this React app also uses relative file paths to correctly reference other files or resources in the project. This is crucial when deploying the app to ArDrive, which we will cover in a different section.
    </p>
  </div>
);

export default HashRouting;
